//----------------| Ecommerce Module |------------------//
import Vue from 'vue';
import gettingRestClientObject from '../../../../services/utils/cms-helper'
var gettingRestClient = gettingRestClientObject();
import router from "../../../router";
import moment from 'moment';
import Snotify, { SnotifyPosition } from 'vue-snotify'
const options = {
      toast: {
            position: SnotifyPosition.rightTop
      }
}
Vue.use(Snotify, options)
const state = {
      cart: [],
      wishlist: [],
      invoiceData: {
            products: [],
            transactionId: '',
            orderedDate: '',
      },
}

// getters
const getters = {
      cart: state => {
            return state.cart;
      },
      wishlist: state => {
            return state.wishlist;
      },
      // tax: state => {
      //       return state.tax;
      // },
      // shipping: state => {
      //       return state.shipping;
      // },
      invoiceData: state => {
            return state.invoiceData;
      },
}

// actions
const actions = {
      addProductToCart(context, payload) {
            context.commit('onAddProductToCart', payload);
      },
      onDeleteProductFromCart(context, payload) {
            context.commit("onDeleteProductFromCart", payload);
      },
      changeQuantityHandler(context, payload) {
            context.commit('onChangeQuantityHandler', payload);
      },
      addItemToWishlist(context, payload) {
            context.commit('onAddItemToWishlist', payload);
      },
      onDeleteProductFromWishlist(context, payload) {
            context.commit("onDeleteProductFromWishlist", payload);
      },
      onPrintFinalReceipt(context, payload) {
            context.commit("onPrintFinalReceipt", payload);
      },
      addAllWishlistItemToCart(context) {
            context.commit("addAllWishlistItemToCart");
      },
      makeOrder(context, payload) {
            context.commit('makeOrder', payload);
      },
      buyNow(context, payload) {
            context.commit('buyNow', payload);
      },
      destroyProducts(context) {
            context.commit('destroyProducts');
      },
      toCart(context, payload) {
            context.commit('toCart', payload);
      },
      toWishlist(context, payload) {
            context.commit('toWishlist', payload);
      },
      destroyCartAndWishlist(context) {
            context.commit('destroyCartAndWishlist');
      },
      removeCartItems(context) {
            context.commit('removeCartItems');
      },
}

// mutations
const mutations = {
      async onAddProductToCart(state, payload) {
            var user = localStorage.getItem("embryo");
            if (user != null && user != undefined) {
                  var userData = JSON.parse(user);
                  var userName = userData.user_data.loginId;
                  const product = payload
                  const cartItems = state.cart.find(item => item.Product_Code === payload.Product_Code)
                  const qty = 1
                  // state.productCategories
                  if (!cartItems) {
                        state.cart.push({
                              ...product,
                              quantitySelected: qty
                        })

                        let requestedDate = moment(String(new Date())).format(
                              "YYYY-MM-DDThh:mm:ss"
                        );
                        let insertCartData = {
                              type: "Cart",
                              keyword1: userName,
                              keyword2: payload.Product_Code,
                              keyword3: payload.Name,
                              keyword4: payload.Category_Name,
                              keyword5: payload.Category_ID,
                              number1: 1,
                              date1: requestedDate,
                        };
                        var cartUpdateSuccess = await gettingRestClient.cmsFormData(
                              insertCartData
                        );
                        try {
                              let insertIDCart = await cartUpdateSuccess;
                              console.log(insertIDCart);
                        } catch (e) {
                              console.log(e);
                        }
                  }
            }
      },

      /**
       * method for deleting product to cart
      */
      async onDeleteProductFromCart(state, payload) {
            const cartItems = state.cart.find(item => item.Product_Code === payload.Product_Code)
            let index = state.cart.indexOf(cartItems);
            state.cart.splice(index, 1);

            var user = localStorage.getItem("embryo");
            if (user != null && user != undefined) {
                  var userData = JSON.parse(user);
                  var userName = userData.user_data.loginId;
                  var items = [];
                  var filterValue = "type='Cart' AND keyword1='" + userName + "'";
                  var allData = await gettingRestClient.getDbDataTableValue(
                        filterValue,
                        "date1"
                  );
                  if (
                        allData != undefined &&
                        allData.data != undefined &&
                        allData.status == 200
                  ) {
                        items = allData.data.data;
                        const cartItem = items.find(
                              (item) => item.keyword2 === payload.Product_Code
                        );
                        if (cartItem) {
                              await gettingRestClient.deleteDbDataTableValue(cartItem.id)
                        }
                  } else {
                        console.log("error:DeleteCartItem");
                  }
            }
      },
      /**
       * method for adding item to wishlist
      */
      async onAddItemToWishlist(state, payload) {
            var user = localStorage.getItem("embryo");
            if (user != null && user != undefined) {
                  var userData = JSON.parse(user);
                  var userName = userData.user_data.loginId;
                  const product = payload
                  const WishlistItems = state.wishlist.find(item => item.Product_Code === payload.Product_Code)
                  const qty = 1
                  if (!WishlistItems) {
                        state.wishlist.push({
                              ...product,
                              quantitySelected: qty
                        })

                        let requestedDate = moment(String(new Date())).format(
                              "YYYY-MM-DDThh:mm:ss"
                        );
                        let insertWishlistData = {
                              type: "WishList",
                              keyword1: userName,
                              keyword2: payload.Product_Code,
                              keyword3: payload.Name,
                              keyword4: payload.Category_Name,
                              keyword5: payload.Category_ID,
                              number1: 1,
                              date1: requestedDate,
                        };
                        var wishlistUpdateSuccess = await gettingRestClient.cmsFormData(
                              insertWishlistData
                        );
                        try {
                              let insertIDWishlist = await wishlistUpdateSuccess;
                              console.log(insertIDWishlist);
                              // Vue.$toast.success(
                              //       self.cmsRequestFunctions.getValidationMsgByCode("M014")
                              // );
                        } catch (e) {
                              console.log(e);
                        }

                  }
            }

      },
      /**
       * method for deleting item from wishlist
      */
      async onDeleteProductFromWishlist(state, payload) {
            const wishItems = state.wishlist.find(item => item.Product_Code === payload.Product_Code)
            let index = state.wishlist.indexOf(wishItems);
            state.wishlist.splice(index, 1);

            var user = localStorage.getItem("embryo");
            if (user != null && user != undefined) {
                  var userData = JSON.parse(user);
                  var userName = userData.user_data.loginId;
                  var items = [];
                  var filterValue = "type='WishList' AND keyword1='" + userName + "'";
                  var allData = await gettingRestClient.getDbDataTableValue(
                        filterValue,
                        "date1"
                  );
                  if (
                        allData != undefined &&
                        allData.data != undefined &&
                        allData.status == 200
                  ) {
                        items = allData.data.data;
                        const WishListItem = items.find(
                              (item) => item.keyword2 === payload.Product_Code
                        );
                        if (WishListItem) {
                              await gettingRestClient.deleteDbDataTableValue(WishListItem.id)
                        }
                  } else {
                        console.log("error:DeleteWishListItem");
                  }
            }
      },

      /**
       * method for adding all wishlist item to cart
      */
      async addAllWishlistItemToCart(state) {
            if (state.wishlist && state.wishlist.length > 0) {

                  var user = localStorage.getItem("embryo");
                  if (user != null && user != undefined) {
                        let requestedDate = moment(String(new Date())).format(
                              "YYYY-MM-DDThh:mm:ss"
                        );
                        var userData = JSON.parse(user);
                        var userName = userData.user_data.loginId;
                        // for (const wishlistItem of state.wishlist) {
                        // let arrayLength = state.wishlist.length;
                        var flag = 0;
                        var flag2 = 0;
                        for (let index = (state.wishlist.length - 1); index >= 0; index--) {
                              const product = state.wishlist[index];
                              if (product.Is_Stock_Available) {
                                    flag = 1;
                                    const cartItems = state.cart.find(item => item.Product_Code === product.Product_Code)
                                    const qty = 1
                                    if (!cartItems) {
                                          state.cart.push({
                                                ...product,
                                                quantitySelected: qty
                                          })

                                          let insertCartData = {
                                                type: "Cart",
                                                keyword1: userName,
                                                keyword2: product.Product_Code,
                                                keyword3: product.Name,
                                                keyword4: product.Category_Name,
                                                keyword5: product.Category_ID,
                                                number1: 1,
                                                date1: requestedDate,
                                          };
                                          try {
                                                var cartUpdateSuccess = await gettingRestClient.cmsFormData(
                                                      insertCartData
                                                );
                                                let insertIDCart = cartUpdateSuccess;
                                                console.log(insertIDCart);
                                          } catch (e) {
                                                console.log(e);
                                          }

                                    }
                                    let index = state.wishlist.indexOf(product);
                                    state.wishlist.splice(index, 1);
                              } else {
                                    flag2 = 1;
                              }
                        }
                        var flag3 = flag + flag2;
                        if (flag3 == 2) {
                              Vue.prototype.$snotify.warning(gettingRestClient.getValidationMsgByCode("M044"), {
                                    closeOnClick: false,
                                    pauseOnHover: false,
                                    timeout: 1000,
                              });
                        } else if (flag3 != 2 && flag == 1) {
                              Vue.prototype.$snotify.success(gettingRestClient.getValidationMsgByCode("M043"), {
                                    closeOnClick: false,
                                    pauseOnHover: false,
                                    timeout: 1000,
                              });
                        } else if (flag3 != 2 && flag2 == 1) {
                              Vue.prototype.$snotify.error(gettingRestClient.getValidationMsgByCode("M045"), {
                                    closeOnClick: false,
                                    pauseOnHover: false,
                                    timeout: 1000,
                              });
                        }
                        // state.wishlist = [];
                        var items = [];
                        var filterValue = "type='WishList' AND keyword1='" + userName + "'";
                        var allData = await gettingRestClient.getDbDataTableValue(
                              filterValue,
                              "date1"
                        );
                        if (
                              allData != undefined &&
                              allData.data != undefined &&
                              allData.status == 200
                        ) {
                              items = allData.data.data;
                              if (items.length) {
                                    for (const item of items) {
                                          await gettingRestClient.deleteDbDataTableValue(item.id)
                                    }
                              }
                        } else {
                              console.log("Error:Delete WishList Item");
                        }
                  }
            }
      },
      /**
       * method to calcualte Order Id , transcation Id, ordered date , delivery date 
      */
      async makeOrder(state, payload) {
            var user = localStorage.getItem("embryo");
            if (user != null && user != undefined) {
                  // var userData = JSON.parse(user);
                  // var userName = userData.user_data.loginId;
                  state.invoiceData.products = [];
                  state.invoiceData.products = state.cart;
                  // state.invoiceData.orderId = '312134645432132132',
                  state.invoiceData.transactionId = new Date().getTime() - 10000,
                        state.invoiceData.orderedDate = moment().format('MMMM DD, YYYY'),
                        state.invoiceData.deliveryDate = moment().add(5, 'days').format('MMMM DD, YYYY')
                  // try {
                  //       var items = [];
                  //       var filterValue = "type='Cart' AND keyword1='" + userName + "'";
                  //       var allData = await gettingRestClient.getDbDataTableValue(
                  //             filterValue,
                  //             "date1"
                  //       );
                  //       if (
                  //             allData != undefined &&
                  //             allData.data != undefined &&
                  //             allData.status == 200
                  //       ) {
                  //             items = allData.data.data;
                  //             if (items.length) {
                  //                   for (const item of items) {
                  //                         try {
                  //                               await gettingRestClient.deleteDbDataTableValue(item.id)

                  //                         } catch (error) {
                  //                               console.log(error, "Error : Delete Cart Item");

                  //                         }
                  //                   }

                  //             }
                  //       } else {
                  //             console.log("Error : Delete Cart Item");
                  //       }
                  // } catch (error) {
                  //       console.log(error, "Error : Delete Cart Item");
                  // }
                  // state.cart = [];
                  if (payload) {
                        router.push('/checkout/payment');
                  } else {
                        router.push('/account/address?to=checkout');
                  }
            }

      },
      buyNow(state, payload) {
            var user = localStorage.getItem("embryo");
            if (user != null && user != undefined) {
                  state.invoiceData.products = [];
                  payload.items.quantitySelected = 1;
                  const newProduct = payload.items;
                  state.invoiceData.products.push(newProduct);
                  // state.invoiceData.orderId = '312134645432132132',
                  state.invoiceData.transactionId = new Date().getTime() - 10000,
                        state.invoiceData.orderedDate = moment().format('MMMM DD, YYYY'),
                        state.invoiceData.deliveryDate = moment().add(5, 'days').format('MMMM DD, YYYY');
                  if (payload.hasAddress) {
                        router.push('/checkout/payment');
                  } else {
                        router.push('/account/address?to=checkout');
                  }
            }

            // state.cart = [];
            // router.push('/checkout/final-receipt')
      },
      destroyProducts(state) {
            state.invoiceData = {
                  products: [],
                  transactionId: '',
                  orderedDate: '',
            }
      },
      toCart(state, payload) {
            const product = payload
            const qty = 1
            const cartItems = state.cart.find(item => item.Product_Code === payload.Product_Code)
            if (!cartItems) {
                  state.cart.push({
                        ...product,
                        quantitySelected: qty
                  })
            }


      },
      toWishlist(state, payload) {
            const product = payload
            const qty = 1
            const WishlistItems = state.wishlist.find(item => item.Product_Code === payload.Product_Code)
            if (!WishlistItems) {
                  state.wishlist.push({
                        ...product,
                        quantitySelected: qty
                  })
            }

      },
      destroyCartAndWishlist(state) {
            state.cart = [];
            state.wishlist = [];
      },
      async removeCartItems(state) {
            
            var user = localStorage.getItem("embryo");
            if (user != null && user != undefined) {
                  var userData = JSON.parse(user);
                  var userName = userData.user_data.loginId;
                  try {
                        var items = [];
                        var filterValue = "type='Cart' AND keyword1='" + userName + "'";
                        var allData = await gettingRestClient.getDbDataTableValue(
                              filterValue,
                              "date1"
                        );
                        if (
                              allData != undefined &&
                              allData.data != undefined &&
                              allData.status == 200
                        ) {
                              items = allData.data.data;
                              if (items.length) {
                                    for (const item of items) {
                                          try {
                                                await gettingRestClient.deleteDbDataTableValue(item.id)

                                          } catch (error) {
                                                console.log(error, "Error : Delete Cart Item");

                                          }
                                    }

                              }
                        } else {
                              console.log("Error : Delete Cart Item");
                        }
                  } catch (error) {
                        console.log(error, "Error : Delete Cart Item");
                  }
                  state.cart = [];
            }
      }


}

export default {
      state,
      getters,
      actions,
      mutations
}
